import { Check } from "lucide-react";

const STEPS = [
  { num: 1, title: "Client", sub: "Site + water" },
  { num: 2, title: "System", sub: "Plumbing & RT" },
  { num: 3, title: "Goal", sub: "Residual & stock" },
  { num: 4, title: "Spec", sub: "Output" },
];

export default function ProgressTracker({ step, onJump }) {
  return (
    <div className="bg-[#111111] border-y-4 border-[#F26522] sticky top-20 z-40" data-testid="progress-tracker">
      <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 py-4">
        <ol className="flex items-center justify-between gap-1 sm:gap-3">
          {STEPS.map((s) => {
            const done = step > s.num;
            const active = step === s.num;
            const clickable = step >= s.num;
            return (
              <li key={s.num} className="flex-1 min-w-0">
                <button
                  disabled={!clickable}
                  onClick={() => clickable && onJump(s.num)}
                  data-testid={`step-jump-${s.num}`}
                  className={`w-full flex flex-col sm:flex-row items-center sm:items-center gap-1 sm:gap-2 p-2 sm:p-3 border-l-4 transition-colors ${
                    active ? "border-[#F26522] bg-black" :
                    done ? "border-[#F26522] bg-transparent" :
                    "border-white/10"
                  } ${clickable ? "hover:bg-black cursor-pointer" : "cursor-not-allowed opacity-50"}`}
                >
                  <div className={`w-8 h-8 shrink-0 flex items-center justify-center font-mono text-xs font-black ${
                    done ? "bg-[#F26522] text-black" :
                    active ? "bg-white text-black" :
                    "bg-white/10 text-white/60"
                  }`}>
                    {done ? <Check className="w-4 h-4" strokeWidth={3} /> : s.num}
                  </div>
                  <div className="text-center sm:text-left min-w-0">
                    <div className={`font-heading text-xs sm:text-sm font-black uppercase tracking-wide truncate ${active || done ? "text-white" : "text-white/60"}`}>
                      {s.title}
                    </div>
                    <div className="hidden sm:block font-mono text-[9px] text-white/40 uppercase tracking-wider truncate">{s.sub}</div>
                  </div>
                </button>
              </li>
            );
          })}
        </ol>
      </div>
    </div>
  );
}
